import * as React from "react";
import css from "./loader.module.css";

const Loader = () => <div className={css["loader"]}></div>;

export default Loader;
